import React, { useState, useRef, useLayoutEffect } from 'react';
import { Typography, Box } from '@mui/material';

const ShowDetail = ({
  text,
  limit = 50,
  sx = {},
  scrollIntoViewOnExpand = true,
  ...props
}) => {
  const [showMore, setShowMore] = useState(false);
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    if (!scrollIntoViewOnExpand || !showMore) return;
    const el = rootRef.current;
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }, [showMore, scrollIntoViewOnExpand]);

  const combinedSx = {
    wordBreak: 'break-word',
    maxWidth: props.maxWidth,
    ...sx,
  };

  if (!text) return null;
  if (text.length <= limit) {
    return (
      <Typography variant="body2" sx={combinedSx}>
        {text}
      </Typography>
    );
  }

  return (
    <Box ref={rootRef} sx={combinedSx}>
      <Typography variant="body2" component="span">
        {showMore ? text : `${text.substring(0, limit)}...`}
      </Typography>
      <Typography
        variant="body2"
        component="span"
        onClick={(e) => {
          e.stopPropagation();
          setShowMore(!showMore);
        }}
        sx={{
          color: '#1976d2',
          cursor: 'pointer',
          ml: 0.5,
          '&:hover': {
            textDecoration: 'underline',
          },
          fontWeight: 600,
          whiteSpace: 'nowrap',
        }}
      >
        {showMore ? ' Show Less' : ' Show More'}
      </Typography>
    </Box>
  );
};

export default ShowDetail;
